<app-spinner-overlay></app-spinner-overlay>

<div class="cont-comp">
  <div appFormElement [larghezza]="1" [riempi]="true">
    <ng-content />
  </div>
  <div style="display: flex; width: 100%; column-gap: 15px">
    <div class="cont-filtri">
      <mat-form-field style="width: 100%" class="ricerca-input">
        <input
          matInput
          placeholder="Inserisci chiave di ricerca"
          [(ngModel)]="searchValue"
          (keyup)="applicaFiltroRicerca($event)"
        />
        <mat-icon matSuffix style="color: var(--mat-color-primary)">search</mat-icon>
      </mat-form-field>
    </div>
    <div class="cont-bottoni">
      <div>
        <button
          mat-flat-button
          class="primary-button"
          color="accent"
          (click)="apriFiltro()"
          [matBadge]="valFiltri.length"
          [matBadgeHidden]="valFiltri.length === 0"
          matBadgeSize="small"
          matBadgeColor="warn"
        >
          <mat-icon matSuffix>filter_list</mat-icon>
          Filtri
        </button>
      </div>
      <div>
        <button
          mat-flat-button
          class="primary-button"
          color="primary"
          (click)="selezionaTutto()"
          [disabled]="disabled || isPermessoSoloRead"
          *ngIf="btnSelezionaTutto === true"
        >
          Seleziona Tutto
        </button>
        <button
          mat-flat-button
          class="primary-button"
          color="primary"
          (click)="deselezionaTutto()"
          [disabled]="disabled || isPermessoSoloRead"
          *ngIf="btnSelezionaTutto === false"
        >
          Deseleziona Tutto
        </button>
      </div>
    </div>
  </div>
</div>

@if (gestionePeso && mostraTutorial) {
  <div class="testo-info">
    <div class="titolo-info" (click)="comeDefinireIlPeso()">
      <div style="font-weight: bold">Come definire il peso degli stakeholder?</div>
    </div>
  </div>
}

<div class="cont-titolo">
  <div>
    <mat-label class="titolo"
      >Stakeholder {{ tipo === 'INTERNI' ? 'Interni' : 'Esterni' }}</mat-label
    >
  </div>

  @if (gestionePeso) {
    <div>
      <div class="totPeso">Tot. Peso: {{ totPeso | async }}</div>
    </div>
  }
</div>
<div style="flex: 1">
  <ng-scrollbar>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let catst of arrayGroupCateStake">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-checkbox
              [checked]="allComplete[catst.id]"
              [indeterminate]="someComplete(catst)"
              (mousedown)="$event.stopPropagation(); $event.preventDefault()"
              (change)="setAll($event.checked, catst)"
              [disabled]="disabled || isPermessoSoloRead"
            >
            </mat-checkbox>
            <span class="nomeStakeholder">{{ catst.titolo }}</span>

            <span class="nrSel">{{ nrSelezionati }}/{{ catst.stakeholders.length }}</span>
          </mat-panel-title>

          @if (gestionePeso) {
            <mat-panel-description>
              <div class="cnt-description-cat">
                <mat-form-field
                  class="mat-field-peso"
                  (click)="$event.stopPropagation()"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Peso</mat-label>
                  <input
                    matInput
                    placeholder="Peso"
                    [value]="catst.pesoAssoluto"
                    type="number"
                    appInputNumber
                    min="0"
                    (input)="cambioPeso($any($event), catst)"
                    (keydown)="onKeyDown($event)"
                    [disabled]="
                      disabled ||
                      isPermessoSoloRead ||
                      (!someComplete(catst) && !allComplete[catst.id])
                    "
                  />
                  @if (someComplete(catst) || allComplete[catst.id]) {
                    <span matTextSuffix class="percentuale">
                      {{
                        calcolaPercentualeDaAssoluto(
                          catst.pesoAssoluto,
                          getTotalePesoCategorie(),
                          catst
                        )
                      }}%</span
                    >
                  }
                </mat-form-field>

                @if (gestioneSceltaCampione) {
                  <button
                    [disabled]="disabled || isPermessoSoloRead"
                    class="icone-button"
                    mat-icon-button
                    (click)="$event.stopPropagation(); modificaSceltaCampione(catst)"
                    title="Motivazione della scelta del campione"
                    aria-label="Motivazione della scelta del campione"
                  >
                    <mat-icon class="icone"> notes </mat-icon>
                  </button>
                }
              </div>
            </mat-panel-description>
          }
        </mat-expansion-panel-header>

        <div
          appFormContainer
          [larghezza]="2"
          *ngFor="let st of catst.stakeholders"
          [alignItems]="'center'"
        >
          <div appFormElement [larghezza]="1" [riempi]="true">
            <mat-checkbox
              (ngModelChange)="onStakeholderToggle(catst, st, $event)"
              [(ngModel)]="st.selected"
              [disabled]="disabled || isPermessoSoloRead"
              (mousedown)="$event.stopPropagation(); $event.preventDefault()"
            >
              <div class="nomeStakeholder">{{ st.cognome }} {{ st.nome }} {{ st.ragSoc }}</div>
            </mat-checkbox>
          </div>
          <div class="azioni-stake" appFormElement [larghezza]="0" [minWidth]="'auto'">
            @if (gestionePeso && pesoPerStakeholder) {
              <mat-form-field
                class="mat-field-peso"
                (click)="$event.stopPropagation(); $event.preventDefault()"
                subscriptSizing="dynamic"
              >
                <mat-label>Peso</mat-label>
                <input
                  matInput
                  placeholder="Peso"
                  [value]="st.pesoAssoluto"
                  type="number"
                  appInputNumber
                  min="0"
                  (input)="cambioPesoStakeholder($any($event), catst, st)"
                  (keydown)="onKeyDown($event)"
                  [disabled]="disabled || isPermessoSoloRead || !st.selected"
                />
                @if (st.selected && gestionePeso && pesoPerStakeholder) {
                  <span matTextSuffix class="percentuale">
                    {{
                      calcolaPercentualeDaAssoluto(
                        st.pesoAssoluto,
                        getTotalePesoSh(catst.stakeholders),
                        st
                      )
                    }}%
                  </span>
                }
              </mat-form-field>
            }

            <button
              class="icone-button"
              mat-icon-button
              (click)="modifica(st)"
              [title]="disabled || isPermessoSoloRead ? 'Visualizza' : 'Modifica'"
              [attr.aria-label]="disabled || isPermessoSoloRead ? 'Visualizza' : 'Modifica'"
            >
              <mat-icon class="icone">
                {{ disabled || isPermessoSoloRead ? 'visibility' : 'edit' }}
              </mat-icon>
            </button>
          </div>
        </div>

        <div>
          <!--  -->
          <button
            mat-stroked-button
            style="height: 56px; width: 100%; font-weight: bold"
            [disabled]="disabled || isPermessoSoloRead"
            (click)="addStake(catst)"
          >
            Aggiungi Stakeholder
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-scrollbar>
</div>
